<div class="modal fade" id="kt_modal_accessory_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Accessory' : 'Add Accessory' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="accessoryForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Accessory Name -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Name</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="name"
                placeholder="Enter accessory name"
                [class.is-invalid]="name?.invalid && name?.touched"
              />
              <div *ngIf="name?.invalid && name?.touched" class="invalid-feedback">
                <div *ngIf="name?.errors?.['required']">Accessory name is required</div>
                <div *ngIf="name?.errors?.['minlength']">Accessory name must be at least 2 characters</div>
              </div>
            </div>

            <!-- Accessory Group -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Group</label>
              <input
                type="text"
                class="form-control form-control-solid"
                formControlName="group"
                placeholder="Enter accessory group"
                [class.is-invalid]="group?.invalid && group?.touched"
              />
              <div *ngIf="group?.invalid && group?.touched" class="invalid-feedback">
                <div *ngIf="group?.errors?.['required']">Accessory group is required</div>
                <div *ngIf="group?.errors?.['minlength']">Accessory group must be at least 2 characters</div>
              </div>
            </div>

            <!-- Type -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Type</label>
              <select
                class="form-select form-select-solid"
                formControlName="type"
                [class.is-invalid]="type?.invalid && type?.touched"
              >
                <option value="">Select type</option>
                <option value="Good Points">Good Points</option>
                <option value="Mechanical Faults">Mechanical Faults</option>
                <option value="Accessories & Options">Accessories & Options</option>
              </select>
              <div *ngIf="type?.invalid && type?.touched" class="invalid-feedback">
                <div *ngIf="type?.errors?.['required']">Type is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
